import getUserPermissions from '../helpers/getUserPermissions'
import useAuth from './useAuth'

const usePermissions = () => {
    const { user } = useAuth()
    const hasPermissions = (feature) => {
        return (
            user &&
            user.permissions &&
            user.permissions.some((role) =>
                getUserPermissions(role).includes(feature)
            )
        )
    }

    return hasPermissions
}

export default usePermissions
